export default __webpack_public_path__ + "static/media/8.2c1e1fd4.png";